module.exports = __webpack_public_path__ + "static/img/default_img_banner@3x.e3dffcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default_img_banner@3x.png
// module id = IBS9
// module chunks = 65